import { motion } from "framer-motion";

const GastonCredibilidad = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(220 69% 2%), hsl(217 61% 8%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#5BA3E0" }}
          >
            El detalle que vos ya viste venir
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1]">
            La autoridad solo vale
            <br />
            <span style={{ color: "#5BA3E0" }}>si es creíble.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="space-y-6 text-base md:text-lg text-white/75 leading-relaxed"
        >
          <p>
            Cuando hablamos de Amelia dijiste algo que es una regla de oro de la
            comunicación pública, y que aplica a vos igual o más: de diez
            aciertos, un solo error en un dato duro y te lo marcan. Queda en un
            recorte, y quedás pegado a ese error.
          </p>
          <p>
            Eso separa la presencia de la autoridad. Publicar por publicar genera
            volumen, y también exposición al error. La autoridad se construye
            con criterio: qué decís, cómo lo decís y qué no decís. No es más
            lento por capricho. Es más sólido, porque cada pieza suma en lugar de
            arriesgar lo que ya construiste.
          </p>
        </motion.div>

        <motion.blockquote
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="font-display italic text-center text-2xl md:text-4xl leading-snug mt-16 px-4"
          style={{ color: "#5BA3E0" }}
        >
          “Empezar rápido, sí. Empezar sin criterio, no.
          <br />
          Porque ahí es donde un error queda en un recorte y te lo marcan.”
        </motion.blockquote>
      </div>
    </section>
  );
};

export default GastonCredibilidad;
